import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { AuthProvider } from './auth-context/auth.context';
import { ProtectedRoute } from './layouts/protected.route.js';
import SignIn from 'views/auth/signIn/index.jsx';
import ErrorBoundary from './ErrorBoundary';
import SetPassword from 'views/auth/setPassword';
import ResetPassword from 'views/auth/resetPassword';
import Company from 'views/admin/companies/company';
import { SelectedPermissionsProvider } from 'contexts/PermissionGroupArrayContext';
import AddPermissionGroupForm from 'views/admin/permissionGroups/components/addPermissionGroup/addPermissionGroupForm';
import { PermissionsProvider } from 'contexts/PermissionContext';
import moment from 'moment-timezone';

//#region logs
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://9188390248d94f99716d662010970d24@o4506574798454784.ingest.us.sentry.io/4507536293560320',
  integrations: [
    new Integrations.BrowserTracing(), // Initialize BrowserTracing integration
    // new Sentry.Replay(), // Initialize Session Replay integration
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: [
  //   /^https:\/\/yourserver\.io\/api/,
  //   "https://admin-pannel-ey1b.vercel.app"
  // ],
  tracePropagationTargets: ['*'],
  // Session Replay
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment:
    process.env.REACT_APP_ENV + '-' + process.env.REACT_APP_CLIENT_NAME,
});
moment.tz.setDefault('Asia/Kolkata');
//#endregion
console.log('SENTRY_DSN:', process.env.SENTRY_DSN);
console.log('REACT_APP_ENV:', process.env.REACT_APP_ENV);
console.log('REACT_APP_CLIENT_NAME:', process.env.REACT_APP_CLIENT_NAME);

let user = null;
try {
  const sessionUser = sessionStorage.getItem('user');
  if (sessionUser && sessionUser !== 'undefined') {
    user = JSON.parse(sessionUser);
  }
} catch (e) {
  console.error('Error parsing user from session storage', e);
}
ReactDOM.render(
  <ErrorBoundary>
    <ChakraProvider theme={theme}>
      <AuthProvider userData={user}>
        <PermissionsProvider>
          <SelectedPermissionsProvider>
            <React.StrictMode>
              <BrowserRouter>
                <Switch>
                  <Route path={`/auth`} component={AuthLayout} />
                  <ProtectedRoute path={`/admin`} component={AdminLayout} />
                  <Route path='/company/:id' component={Company} />
                  <Route
                    path='/addpermissiongroup'
                    component={AddPermissionGroupForm}
                  />
                  <Route path='/signin' component={SignIn} />
                  <Route path='/setpassword' component={SetPassword} />

                  <Route path='/resetpassword' component={ResetPassword} />
                  {/* <ProtectedRoute path={`/rtl`} component={RTLLayout} /> */}
                  <Redirect from='/' to='/admin' />
                </Switch>
              </BrowserRouter>
            </React.StrictMode>
          </SelectedPermissionsProvider>
        </PermissionsProvider>
      </AuthProvider>
    </ChakraProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);
